/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_To_TypescriptInputs */

const en_sidebar_to_typescript = /** @type {(inputs: Sidebar_To_TypescriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → TypeScript`)
};

const ko_sidebar_to_typescript = /** @type {(inputs: Sidebar_To_TypescriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → TypeScript`)
};

const ja_sidebar_to_typescript = /** @type {(inputs: Sidebar_To_TypescriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → TypeScript`)
};

/**
* | output |
* | --- |
* | "JSON → TypeScript" |
*
* @param {Sidebar_To_TypescriptInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_to_typescript = /** @type {((inputs?: Sidebar_To_TypescriptInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_To_TypescriptInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_to_typescript(inputs)
	if (locale === "ko") return ko_sidebar_to_typescript(inputs)
	return ja_sidebar_to_typescript(inputs)
});